import React from 'react';
import TextField from "@material-ui/core/TextField/TextField";
import {makeStyles} from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
}));

const FieldFloat = ({name, scheme, defaultValue, refs}) => {
    const classes = useStyles();
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    return (
        <React.Fragment>
            <TextField
                type="number"
                inputProps={{step: Math.pow(0.1 , scheme.type.accuracy).toFixed(scheme.type.accuracy)}}
                label={currentLang === 'en' ? scheme.label_en : scheme.label}
                inputRef={input => refs[name] = input}
                variant="outlined"
                size="small"
                fullWidth
                defaultValue={defaultValue}
                required={scheme.required === true}/>
        </React.Fragment>
    );
};
export default FieldFloat;